import React, { useMemo, useState } from "react";
import { unlockPasswordGate } from "../utils/passwordGateAccess";

export default function PasswordUnlock({ gate, componentId, onUnlocked }) {
    const [passwordInput, setPasswordInput] = useState("");
    const [error, setError] = useState("");

    const targetId = useMemo(
        () => String(componentId ?? '').trim() || String(gate?.targetId || ""),
        [gate?.targetId, componentId]
    );
    const configuredPassword = String(gate?.password || "");
    const isConfigured = configuredPassword.length > 0;
    const promptText = String(gate?.passwordPrompt || '').trim() || "Enter password to unlock this panel.";

    const handleUnlock = () => {
        setError("");
        if (!isConfigured) {
            setError("Password gate is not configured.");
            return;
        }

        const ok = unlockPasswordGate(
            { ...(gate || {}), targetId },
            passwordInput,
            targetId
        );

        if (!ok) {
            setError("Incorrect password.");
            return;
        }

        setPasswordInput("");
        if (typeof onUnlocked === "function") onUnlocked();
    };

    return (
        <div style={{ marginTop: 12 }}>
            <div style={{ fontSize: 14, opacity: 0.9 }}>
                {promptText}
            </div>
            <div style={{ display: "flex", gap: 8, marginTop: 8, flexWrap: "wrap" }}>
                <input
                    className="muulti-input"
                    type="password"
                    autoComplete="off"
                    value={passwordInput}
                    onChange={(e) => setPasswordInput(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") handleUnlock();
                    }}
                    placeholder="Password"
                    style={{ minWidth: 180 }}
                />
                <button
                    className="muulti-button"
                    type="button"
                    onClick={handleUnlock}
                    disabled={!isConfigured}
                >
                    Unlock
                </button>
            </div>
            {error ? (
                <div style={{ marginTop: 8, fontSize: 13, color: "#b00020" }}>{error}</div>
            ) : null}
        </div>
    );
}
